module.exports = __webpack_public_path__ + "img/empreendimento-logo-21.35effce7.png";